<template>
  <div>
    <v-toolbar>
      <v-toolbar-title @click="$router.push('/')">
        <img
          style="margin-top:8px"
          src="https://static.paymentiq.io/worldline-logo.svg"
          width="150px"
          alt="Bambora logo">
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn @click="reloadCashierMutation" outlined class="theme-main-color mr-3" small rounded>
        <v-icon small>mdi-reload</v-icon>
      </v-btn>

      <template>
        <v-btn @click="menuClick" icon>
          <v-icon style="color:#000000">mdi-menu</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'Small-header',
  props: {
    menuClick: { type: Function, required: true }
  },
  methods: {
    ...mapMutations([
      'reloadCashierMutation'
    ])
  }
}
</script>

<style>
</style>
